<template>
  <div class="c-validation" :class="{'c-validation-failed': errors.length > 0}">
    <slot/>
    <p v-for="error in errors" class="c-validation-error">{{ $t(`validation.${error.key}`, error.params) }}</p>
  </div>
</template>

<script setup lang="ts">
  import { onBeforeUnmount, ref, watch } from 'vue';
  import { getFormController } from '../../utils/form/form';
  import { validate, ValidationError, ValidatorMap } from '../../utils/form/validation';

  const props = defineProps<{
    value: any;
    validators: ValidatorMap;
  }>();

  const errors = ref<Array<ValidationError>>([]);

  const apply = async () => {
    errors.value = await validate(props.value, props.validators);
    return errors.value.length === 0;
  };

  defineExpose({ apply });

  const form = getFormController();
  if (form) {
    form.addValidationHook(apply);
    onBeforeUnmount(() => form.removeValidationHook(apply));
  }

  watch(() => props.value, async () => {
    if (errors.value.length === 0) return;
    const cheapErrors = errors.value.filter(e => !e.expensive && props.validators[e.key]);
    const remainingValidators = Object.fromEntries(cheapErrors.map(e => [e.key, props.validators[e.key]]));
    errors.value = await validate(props.value, remainingValidators);
  });
</script>

<style lang="scss">
  .c-validation-error {
    font-size: .85em;
    color: $danger;
  }
</style>